import type { AnchorHTMLAttributes } from 'react';
import { cn } from '../utils';
import { headerIconAffordanceClassName } from './HeaderIconButton';

export interface HeaderIconLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  'aria-label': string;
  href: string;
}

export function HeaderIconLink({ className, children, ...props }: HeaderIconLinkProps) {
  return (
    <a className={cn(headerIconAffordanceClassName, className)} {...props}>
      {children}
    </a>
  );
}
